import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import useFormatMessage from '@alltrails/shared/hooks/useFormatMessage';
import * as styles from './styles/styles.module.scss';
import OUR_VALUES_STRINGS from './ourValues.strings';

type AllTrailsValue = {
  value: string;
  desc: string;
};

const OurValues = (): JSX.Element => {
  const {
    formattedDefaultMessages: {
      SpreadStoke,
      SpreadStokeDesc,
      LeadByExample,
      LeadByExampleDesc,
      EmbraceChange,
      EmbraceChangeDesc,
      DownToEarh,
      DownToEarhDesc,
      AllWelcome,
      AllWelcomeDesc
    }
  } = useFormatMessage(OUR_VALUES_STRINGS);
  const values: AllTrailsValue[] = [
    { value: SpreadStoke, desc: SpreadStokeDesc },
    { value: LeadByExample, desc: LeadByExampleDesc },
    { value: EmbraceChange, desc: EmbraceChangeDesc },
    { value: DownToEarh, desc: DownToEarhDesc },
    { value: AllWelcome, desc: AllWelcomeDesc }
  ];

  return (
    <div className={styles.container}>
      <div className={styles.innerContainer}>
        <div className={classNames(styles.textContainer, styles.title)}>
          <h2 className={styles.header}>
            <FormattedMessage defaultMessage="Values inspired by the trail" />
          </h2>
          <div className={styles.subHeader}>
            <FormattedMessage defaultMessage="AllTrails was founded on the idea that we’re all made better by spending time in nature. Today, we continue to be driven by the desire to share the outdoors with as many people in as many places as possible — and to do so responsibly and respectfully." />
          </div>
        </div>
        <div className={styles.textContainer}>
          {values.map((valueInfo: AllTrailsValue) => (
            <div className={styles.valueContainer} key={valueInfo.value.toLowerCase().split(' ').join('-')}>
              <div className={styles.value}>{valueInfo.value}</div>
              <div className={styles.valueDesc}>{valueInfo.desc}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export { OurValues as default, AllTrailsValue };
